import React from 'react';
import { ASSETS } from './assetPaths';
import './PhoneMockup.css';

function PhoneMockup({ type, src, alt, className = 'phone-mockup' }) {
  return (
    <div className={className}>
      <div className={`${className}__screen`}>
        {type === 'video' ? (
          <video src={src} autoPlay loop muted playsInline aria-label={alt} />
        ) : (
          <img src={src} alt={alt} loading="lazy" />
        )}
      </div>
      <img className={`${className}__frame`} src={ASSETS.iphoneFrame} alt="" aria-hidden="true" />
    </div>
  );
}

export default PhoneMockup;
